<template>
  <div class="serial-code-table">
    <div class="mb-x2" layout layout-align="space-between-center">
      <!-- 追加-->
      <el-button type="primary" @click="changeTab('serial-code-create')"><i class="mdi mdi-plus"></i>追加</el-button>
      <el-select v-model="messageId" placeholder="対象メッセージ" :disabled="isEdit">
        <el-option :value="0" label="全てのメッセージ"></el-option>
        <el-option
          v-for="(message, index) in messages"
          :value="message.id"
          :label="message.name"
          :key="index"
        ></el-option>
      </el-select>
      <!-- フィルタ-->
      <select-form
        class="status-filter"
        :value="status.value"
        :options="status.options"
        :onChange="status.onChange"
      ></select-form>
      <!-- 一括操作-->
      <el-dropdown trigger="click" @command="selectAction">
        <el-button type="default"
          ><i class="mdi mdi-playlist-play"></i>一括操作<i class="mdi mdi-chevron-down ml-x2 mr-0"></i
        ></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(option, index) in action.options" :key="index" :command="option.value">{{
            option.label
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <csv-download :download="downloadCsv"></csv-download>
    </div>
    <div class="mb-x1" v-if="existSerialCodes">
      <div class="message message-warning">
        シリアルコードをURLに含める場合、正しくアクセスできることを必ず確認してください。
      </div>
    </div>
    <el-table
      :data="serialCodes"
      stripe
      @header-click="headerClick"
      style="width: 100%"
      empty-text="データがありません。"
    >
      <!-- 対象メッセージ-->
      <el-table-column label="対象メッセージ" sort-by="-message_name" :render-header="renderHeader" min-width="20%">
        <template slot-scope="scope">{{ scope.row.messageName }}</template>
      </el-table-column>
      <!-- ステータス-->
      <el-table-column label="ステータス" sort-by="-status" :render-header="renderHeader" min-width="20%">
        <template slot-scope="scope">
          <div class="text-success" v-if="scope.row.applicant">
            {{ '割り当て済' }}
            <div class="text-sub-color" v-if="scope.row.userIsUsed">使用済み</div>
          </div>
          <div class="text-disabled" v-else>未割り当て</div>
        </template>
      </el-table-column>
      <!-- シリアルコード-->
      <el-table-column label="シリアルコード" sort-by="serial_code" :render-header="renderHeader" min-width="30%">
        <template slot-scope="scope">
          <div v-html="convertSerialCode(scope.row.serialCode)"></div>
        </template>
      </el-table-column>
      <!-- 割り当てアカウント-->
      <el-table-column label="割り当てアカウント" sort-by="name" :render-header="renderHeader" min-width="25%">
        <template slot-scope="scope">
          <applicant-name v-if="scope.row.applicant" :applicant="scope.row.applicant"></applicant-name>
          <div v-else layout-align="start">-</div>
        </template>
      </el-table-column>
      <el-table-column min-width="10%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <el-tooltip :enterable="false" placement="top" content="削除">
              <el-button class="el-button--icon" type="default" @click="deleteSerialCode(scope.row.id)"
                ><i class="mdi mdi-delete-forever"></i
              ></el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-x2" layout layout-align="space-between-center">
      <pagination
        flex="1"
        :total="total"
        :pagingNo="params.pagingNo"
        :limitCount="params.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

:deep(.el-input__inner) {
  height: $spacing-unit * 4;
}

.text-sub-color {
  font-size: $font-small-size;
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import twitterText from 'twitter-text'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import CsvDownload from '@/client/components/_atoms/csv_download'
import Pagination from '@/client/components/_atoms/pagination'
import SelectForm from '@/client/components/_atoms/select_form'
import api from '@/client/core/api'
import Util from '@/client/core/util'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  data() {
    return {
      title: 'シリアルコードの管理',
      visible: false,
      messageId: '',
      status: {
        value: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '割り当て済',
            value: 'assign'
          },
          {
            label: '未割り当て',
            value: 'unassigned'
          }
        ],
        onChange: (value: number) => {
          this.status.value = value
          if (this.params.filter === value) {
            return
          }

          // オプションを切り替えるときは 1 ページに戻る
          this.setSerialCodeListParams({ filter: value, pagingNo: 1 })
        }
      },
      action: {
        options: [
          {
            label: '使用済みコードインポート',
            value: 'serial-code-used-import'
          },
          {
            label: '使用済みコード解除',
            value: 'serial-code-used-resets'
          },
          {
            label: '未割り当てコード削除',
            value: 'serial-code-unassigned-delete'
          }
        ]
      }
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CsvDownload,
    SelectForm,
    Pagination,
    ApplicantName
  },
  watch: {
    params() {
      this.fetchSerialCodeList()
    },
    serialCodes() {
      this.status.options[0].label = '指定なし' + ` (${this.dataCount.countAssign + this.dataCount.countUnassign})`
      this.status.options[1].label = '割り当て済' + ` (${this.dataCount.countAssign})`
      this.status.options[2].label = '未割り当て' + ` (${this.dataCount.countUnassign})`
    },
    messageId() {
      this.setMessageId(this.messageId)

      // オプションを切り替えるときは 1 ページに戻る
      this.setSerialCodeListParams({ pagingNo: 1 })
    }
  },
  mounted() {
    this.messageId = this.currentMessageId
    if (this.isEdit) {
      this.action = {
        options: [
          {
            label: '未割り当てコードの削除',
            value: 'serial-code-unassigned-delete'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinSerialCodeStore, {
      currentMessageId: state => state.messageId,
      serialCodes: state => state.serialCode.list,
      params: state => state.serialCode.params,
      total: state => state.serialCode.total,
      dataCount: state => {
        return {
          countAssign: state.serialCode.countAssign,
          countUnassign: state.serialCode.countUnassign
        }
      }
    }),

    ...mapState(useTwitterInstantwinMessageStore, {
      messages: state => state.messages.filter(message => message.messageType === 'win')
    }),

    existSerialCodes() {
      return this.serialCodes.length > 0
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinSerialCodeStore, [
      'fetchSerialCodeList',
      'setSerialCodeListParams',
      'setMessageId'
    ]),
    ...mapActions(useTwitterInstantwinMessageStore, ['fetchInstantwinMessages']),

    changeTab(tab: string) {
      this.$emit('change_tab', tab)
    },

    /**
     * Set message id
     * @param {number} messageId
     */
    changeMessageId(messageId: number) {
      this.messageId = messageId
    },

    /**
     * Change status value
     * @param {string} status
     */
    changeStatus(status: string) {
      this.status.value = status
    },

    /**
     * シリアルコードにURLが含まれる場合、アンカーリンクにする
     * @param {string} serialCode
     * @returns {string}
     */
    convertSerialCode(serialCode: string): string {
      const escapeSerialCode = this.htmlEscape(serialCode)
      const entities = twitterText.extractEntitiesWithIndices(escapeSerialCode, {
        extractUrlsWithoutProtocol: true
      })
      return twitterText.autoLinkEntities(escapeSerialCode, entities, {
        targetBlank: true
      })
    },
    /**
     * HTMLで使用する特殊文字を除去する
     */
    htmlEscape(text: string): string {
      const entities = {
        '>': '&gt;',
        '<': '&lt;',
        '"': '&quot;',
        "'": '&#39;'
      }

      return text.replace(/["'><]/g, character => entities[character])
    },
    /**
     * Delete serial code
     * @param {number} serialCodeId
     */
    async deleteSerialCode(serialCodeId: number) {
      const confirm = window.confirm('シリアルコードを削除してよろしいですか?')

      if (!confirm) {
        return
      }

      const result = await api.delete(`/twitter_instantwin_serial_codes/${serialCodeId}`)

      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象のシリアルコードはすでに削除されています。',
          message: '',
          customClass: 'danger',
          duration: 5000
        })

        this.fetchSerialCodeList()
        this.fetchInstantwinMessages()
        return
      }

      // エラーがある場合はエラーメッセージを表示
      if (!result.data) {
        this.$notify({
          title: 'シリアルコードの削除に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: 'シリアルコードを削除しました。',
        message: '',
        customClass: 'success',
        duration: 5000
      })

      this.fetchSerialCodeList()
      this.fetchInstantwinMessages()
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      const campaignId = this.campaignId
      const params = { ...this.params, campaignId, limitCount: -1 }

      const result = await api.get('/twitter_instantwin_serial_codes', {
        params
      })

      if (!result.data) {
        return {
          error: 'ERROR_LOADING'
        }
      }

      const serialCodeList = result.data.serialCode
      const filename = `campaign_instantwin_serial_codes_${moment().format('YYYY_MM_DD')}`
      const csvData = []

      csvData.push(['No', '対象メッセージ', 'ステータス', 'シリアルコード', '使用済み'])

      serialCodeList.forEach((serialCode, index) => {
        csvData.push([
          index + 1,
          serialCode.messageName,
          serialCode.applicant ? '割り当て済' : '未割り当て',
          serialCode.serialCode,
          serialCode.userIsUsed
        ])
      })

      return {
        filename,
        data: csvData
      }
    },

    /**
     * シリアルコード一覧ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      if (this.params.sortBy === sortBy) {
        return
      }
      this.setSerialCodeListParams({ sortBy })
    },

    /**
     * ページを変更イベント
     * @param {number} pagingNo ページング
     */
    onChangePagingNo(pagingNo: number) {
      this.setSerialCodeListParams({
        pagingNo
      })
    },

    /**
     * ページを変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      this.setSerialCodeListParams({
        limitCount,
        pagingNo: 1
      })
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (column.sortBy.indexOf('-') === 0) {
        if (this.params.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.params.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.params.sortBy, column.sortBy))
    },

    /**
     * 選択した一括操作を実行
     * @param {string} action action
     */
    selectAction(action: string) {
      this.changeTab(action)
    }
  }
})
</script>
